
import './assets/css/bootstrap.css';
import './assets/css/icons.css';
import './assets/css/app.css';
import './assets/css/custom.css';
import 'react-toastify/dist/ReactToastify.css';
import Layout from './Layouts';
import { BrowserRouter, RouterProvider } from 'react-router-dom';
import React, { useContext, useEffect } from 'react';
import RoutesMaster from './Components/Constants/RoutesMaster';
import { GlobalStore } from './StateStores';
import { ReactSession } from 'react-client-session';

function App() {
  const{authState:{AuthState:{isLoggedIn}}} = useContext(GlobalStore);
  const[isAuthenticated, setIsAuthenticated] = React.useState(isLoggedIn);
  const[userData,setUserData] = React.useState({});
  const[tokenExp,setTokenExp] = React.useState("");
  const[timer,setTimer] = React.useState();


  const getUserdata = async () => {
    try{
      const user = await ReactSession.get("csmit_userdata");
      const exp = await ReactSession.get('csmit_tokenExpiresIn');

      if(user){
        setIsAuthenticated(true);

        let parseData = JSON.parse(user);
        //calling set function from the useState
        setUserData(parseData);

        //Set tokenExp
        setTokenExp(exp)

      }else{
        setIsAuthenticated(false);
      }
    } catch(error){}
  }

  useEffect(() => {
    getUserdata();
  }, [isLoggedIn])


  return (
        <>
          <RouterProvider router={RoutesMaster(isAuthenticated,userData)}>
            <BrowserRouter></BrowserRouter>
          </RouterProvider>
        </>
  );
}

export default App;
